/**
 * Batch Processes List Store
 */

import { createStore } from '@commandDrivenStateEngine/core/createStore';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
import { Policy } from '@commandDrivenStateEngine/core/policies';
import { initialState } from './state';
import { handlers } from './handlers';
import { invariants } from './invariants';
import { BatchProcessesListState } from './state';
import { BatchProcessesListCommand } from './commands';
import { createHistoryQueryPolicy } from './policies/historyQueryPolicy';

export { selectors } from './state';

const store = createStore({
  name: 'batch-processes-list',
  initialState,
  handlers,
  invariants
});

export const {
  useSelector: useBatchProcessesListSelector,
  useErrors: useBatchProcessesListErrors,
  useDispatch: useBatchProcessesListDispatch,
  usePolicies: useBatchProcessesListPolicies,
  getState: getBatchProcessesListState,
  dispatch: dispatchBatchProcessesListCommand
} = store;

/**
 * Policy factory - creates policies that require backend.
 */
export const createBatchProcessesListPolicies = (
  backend: ClientLibraryType
): Policy<BatchProcessesListState, BatchProcessesListCommand>[] => [
  createHistoryQueryPolicy( backend )
];
